import getCollection from './getCollection'
import getDocRef from 'actions/base/getDocRef'

const getSlotTimetableRef = (id) => getDocRef(id, getCollection())

export default getSlotTimetableRef
